import { combineReducers } from 'redux';
import ImageCarousel from './modules/ImageCarousel';

const reducer = combineReducers({
  ImageCarousel,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/store/index.js